import React from 'react';
import SearchIcon from 'svg/SearchIcon';

interface Props {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
  size?: 'sm' | 'md';
  sizeDesktop?: 'sm' | 'md';
  sizeMobile?: 'sm' | 'md';
  inverted?: boolean;
}

export default function SearchInput({
  value,
  onChange,
  placeholder = 'Search',
  className,
  size = 'md',
  sizeDesktop,
  sizeMobile,
  inverted = false,
}: Props) {
  const isSm = size === 'sm';
  const desktopSm = sizeDesktop === 'sm';
  const mobileSm = sizeMobile === 'sm';

  const iconClass =
    sizeDesktop || sizeMobile
      ? `${desktopSm ? 'h-4 w-4' : 'h-5 w-5'} ${
          mobileSm ? 'max-md:h-4 max-md:w-4' : 'max-md:h-5 max-md:w-5'
        }`
      : isSm
      ? 'h-4 w-4'
      : 'h-5 w-5';

  const inputClass =
    sizeDesktop || sizeMobile
      ? `${desktopSm ? 'h-8 pl-9 text-sm' : 'h-11 pl-11'} ${
          mobileSm ? 'max-md:h-8 max-md:pl-9 max-md:text-sm' : 'max-md:h-11 max-md:pl-11'
        }`
      : isSm
      ? 'h-8 pl-9 text-sm'
      : 'h-11 pl-11';

  return (
    <div className={`relative h-fit w-full max-w-sm ${className ?? ''}`}>
      <SearchIcon
        className={`absolute left-4 top-1/2 -translate-y-1/2 ${iconClass} ${
          inverted
            ? 'text-color-text-lightmode-invert dark:text-color-text-darkmode-invert'
            : 'text-color-text-lightmode-placeholder dark:text-color-text-darkmode-placeholder'
        }`}
      />
      <input
        type="search"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className={`w-full rounded-full pr-4 ${inputClass} ${
          inverted
            ? 'border-0 bg-color-bg-lightmode-invert-secondary text-color-text-lightmode-invert placeholder:text-color-text-lightmode-invert/40 focus:!border-0 focus:shadow-none focus:!outline-none focus:ring-0 dark:bg-color-bg-darkmode-invert dark:text-color-text-darkmode-invert dark:placeholder:text-color-text-darkmode-invert/40'
            : 'input-base-form'
        }`}
      />
    </div>
  );
}
